import { parseISO, format } from 'date-fns';
import TransitDataDTO, { LoadDTO } from '../infrastructure/dto/TransitsDTO';
import GetDateFormatedService from 'modules/inbound/shared/domain/GetDateFormatedService';

export interface loadTransists {
  id: number;
  plateNumber: string;
  deliveryTime: string;
  deliveryTimeDate: string;
  amount: number;
  providerDeliveryNote: string;
}

export interface Transits {
  code: string;
  providerId: number;
  loads: loadTransists[];
  date: string;
}

interface GenerateFromDTOParams extends TransitDataDTO {
  code: string;
  provider_id: number;
  loads: LoadDTO[];
}

class TransitsData {
  transits: Transits;

  constructor({ transits }: TransitsData) {
    this.transits = transits;
  }

  static generateFromDTO({
    loads,
    code,
    provider_id
  }: GenerateFromDTOParams): TransitsData {
    let formatLoads: loadTransists[] = [];

    formatLoads = loads.map((load) => {
      const fechaFormated = parseISO(load.delivery_time);
      return {
        id: load.id,
        amount: load.quantity,
        deliveryTime: `${GetDateFormatedService.getTimeFormated(
          load.delivery_time
        )}h`,
        deliveryTimeDate: format(fechaFormated, 'dd/MM/yyyy'),
        providerDeliveryNote:
          load.provider_delivery_note !== ''
            ? load.provider_delivery_note
            : '-',
        plateNumber: load.plate_number
      };
    });
    const formatTransits: Transits = {
      code: code,
      providerId: provider_id,
      loads: formatLoads,
      date: loads[0].delivery_time
    };
    return new TransitsData({
      transits: formatTransits
    });
  }
}

export default TransitsData;
